<template>
	<div class="">
		<div class="w-full bg-white h-[74px]">
			<examHeader :title="title"></examHeader>
			<div class="2xl:w-[1200px] xl:w-[1200px] lg:w-[1000px] mx-auto flex justify-between">
				<div class="lg:w-[700px] 2xl:w-[900px] xl:w-[900px] h-[78vh]  mr-[10px] flex flex-col overflow-hidden">
					<div
						class="relative flex-1 overflow-y-auto shadow-01 rounded-[6px] mb-[10px] bg-white py-[30px] px-[22px] box-border">
						<div class="mb-[42px] relative z-10">

							<div v-if="current_question_type=='case'"
								class="answerSheetTitle bB-01  p-[16px] box-border relative text-[16px] text-[#1B2128] font-bold">
								【{{langInfo['Case description']}}】
							</div>
							<div v-if="current_question_type=='case'"
								class="pt-[16px] px-[13px] mb-[20px] box-border relative" style="line-height: 1.6;">
								<label v-html="caseTopicInfo.content"></label>
							</div>

							<div class="flex  mb-[20px]">
								<el-tooltip class="item" effect="dark"
									:content="currentTopicInfo.is_user_collection==1?langInfo['cancel_collect']:langInfo['click_collect']" placement="bottom">
									<img @click="collectClick()"
										:src="currentTopicInfo.is_user_collection==1?collectActive:collectImg"
										class="w-[24px] h-[24px] mr-[10px] cursor-pointer" alt="" srcset="" />
								</el-tooltip>
								<div class="flex-1 text-[18px] text-[#101010] font-semibold flex">
									{{currentTopic + 1 }}.<span v-html="currentTopicInfo.content"
										class="whitespace-pre-wrap"></span>
								</div>
							</div>
							<div class="pl-[68px] box-border text-[#101010]" v-if="currentTopicInfo.question_type==1">
								<div v-for="(item,index) in optionsList" class="flex items-center mb-[10px] ">
									<img :src="item.isSelect?selectedImg:selectImg"
										class="w-[14px] h-[14px] mr-[10px]" />
									<label class="mr-[14px]">{{item.key}}.</label><label class="cursor-pointer"
										v-html="item.value"></label>
								</div>
							</div>

							<div class="pl-[68px] box-border text-[#101010]"
								v-else-if="currentTopicInfo.question_type==3">
								<!-- 判断题传 1对0错 -->
								<div class="flex items-center mb-[10px] cursor-pointer">
									<img :src="currentUserRecord.user_answer=='1'?selectedImg:selectImg"
										class="w-[14px] h-[14px] mr-[10px]" />
									<label class="mr-[14px] cursor-pointer">{{langInfo['right']}}</label>
								</div>
								<div class="flex items-center mb-[10px] cursor-pointer">
									<img :src="currentUserRecord.user_answer=='0'?selectedImg:selectImg"
										class="w-[14px] h-[14px] mr-[10px]" />
									<label class="mr-[14px] cursor-pointer">{{langInfo['wrong']}}</label>
								</div>
							</div>
							<div class="pl-[68px] box-border text-[#101010]"
								v-else-if="currentTopicInfo.question_type==5">
								<textarea maxlength="200" disabled class="w-[100%] h-[160px]"
									v-model="currentUserRecord.user_answer"></textarea>
							</div>

						</div>
						<div class="bg-[#F5F5F5] p-[22px] box-border mb-[18px]">
							<div class="" v-if="currentTopicInfo.question_type==1">
								<div class="flex items-center mb-[10px]">
									<img v-if="currentUserRecord.user_answer==currentTopicInfo.answer"
										src="@/static/image/icon40.png" class="w-[24px] h-[24px] mr-[10px]" alt="" />
									<img v-else src="@/static/image/icon41.png" class="w-[24px] h-[24px] mr-[10px]"
										alt="" />
									<label v-if="currentUserRecord.user_answer==currentTopicInfo.answer"
										class="text-[20px] font-bold text-[#68C340]">{{langInfo.study_paper_answer_right}}</label>
									<label v-else
										class="text-[20px] font-bold text-[#FF0100]">{{langInfo.study_paper_answer_wrong}}</label>
								</div>
								<div class="text-[16px] text-[#101010] font-semibold mb-[10px]">
									<label class=" min-w-[80px]">{{langInfo.study_paper_answer_user}}：</label>
									<label
										:class="currentUserRecord.user_answer==currentTopicInfo.answer?'text-[#68C340]':'text-[#FF0100]'">{{currentUserRecord.user_answer ||langInfo['no_answer']}}</label>
								</div>
								<div class="text-[16px] text-[#101010] font-semibold mb-[10px]">
									<label class=" min-w-[80px]">{{langInfo.study_paper_answer_standard}}：</label>
									<label>{{currentTopicInfo.answer}}</label>
								</div>
							</div>
							<div class="" v-else-if="currentTopicInfo.question_type==3">
								<div class="flex items-center mb-[10px]">
									<img v-if="(currentTopicInfo.answer==currentUserRecord.user_answer=='1') &&currentUserRecord.user_answer!=''"
										src="@/static/image/icon40.png" class="w-[24px] h-[24px] mr-[10px]" alt="" />
									<img v-else-if="(currentTopicInfo.answer==currentUserRecord.user_answer=='0') &&currentUserRecord.user_answer!=''"
										src="@/static/image/icon40.png" class="w-[24px] h-[24px] mr-[10px]" alt="" />
									<img v-else="(currentTopicInfo.answer==currentUserRecord.user_answer=='0') &&currentUserRecord.user_answer!=''"
										src="@/static/image/icon41.png" class="w-[24px] h-[24px] mr-[10px]" alt="" />
									<label
										v-if="(currentTopicInfo.answer==currentUserRecord.user_answer=='1') &&currentUserRecord.user_answer!=''"
										class="text-[20px] font-bold text-[#68C340]">{{langInfo.study_paper_answer_right}}</label>

									<label
										v-else-if="(currentTopicInfo.answer==currentUserRecord.user_answer=='0') &&currentUserRecord.user_answer!=''"
										class="text-[20px] font-bold text-[#68C340]">{{langInfo.study_paper_answer_right}}</label>


									<label v-else
										class="text-[20px] font-bold text-[#FF0100]">{{langInfo.study_paper_answer_wrong}}</label>
								</div>
								<div class="text-[16px] text-[#101010] font-semibold mb-[10px]">
									<label class=" min-w-[80px]">{{langInfo.study_paper_answer_user}}：</label>
									<label v-if="currentUserRecord.user_answer=='1'&&currentUserRecord.user_answer!=''"
										class="text-[#68C340]">{{langInfo['right']}}</label>
									<label
										v-else-if="currentUserRecord.user_answer=='0'&&currentUserRecord.user_answer!=''"
										class="text-[#68C340]">{{langInfo['wrong']}}</label>
									<label v-else>{{langInfo['no_answer']}}</label>
								</div>
								<div class="text-[16px] text-[#101010] font-semibold mb-[10px]">
									<label class=" min-w-[80px]">{{langInfo.study_paper_answer_standard}}：</label>
									<label>{{currentTopicInfo.answer=='1'?langInfo['right']:langInfo['wrong']}}</label>
								</div>
							</div>
							<div class="" v-else-if="currentTopicInfo.question_type==5">
								<div class="text-[16px] text-[#101010] font-semibold mb-[10px]">
									<label class=" min-w-[80px]">{{langInfo.study_paper_answer_user}}：</label>
									<label
										:class="currentUserRecord.user_answer==currentTopicInfo.answer?'text-[#68C340]':'text-[#FF0100]'">{{currentUserRecord.user_answer ||langInfo['no_answer']}}</label>
								</div>
							</div>


							<div class="text-justify text-[16px]  text-[#101010] flex ">
								<label class="font-semibold  min-w-[80px] flex justify-between">
									{{langInfo.study_paper_answer_tip}}：</label>


								<div v-html="currentTopicInfo.analysis"
									class="flex-1 text-[#101010] whitespace-pre-wrap">
								</div>
							</div>
						</div>
						<div @click="askVisible=true"
							class="cursor-pointer relative z-10 flex items-center text-[#D86D21] text-[16px]">
							<img src="@/static/image/icon42.png" class="w-[20px] h-[20px] mr-[4px]" alt="" />
							{{langInfo.study_paper_answer_submit}}
						</div>
						<!-- 水印 -->
						<div class=" absolute w-full h-full top-0 left-0 bg-repeat"
							:style="{ backgroundImage: svgWatermark1+watermarkContent+svgWatermark2}">
						</div>
						<!-- 水印 -->
					</div>
					<div class="shadow-01 rounded-[6px] h-[56px] bg-white flex items-center justify-center">
						<div @click="preTopic()" :class="currentNumber==1?'bg-[#8FC3FF]':'bg-[#2979FF] '"
							class="min-w-[100px] px-[10px] box-border h-[28px] leading-[28px] mr-[14px] text-center text-[14px] text-white rounded-[6px] cursor-pointer">
							{{langInfo.study_paper_answer_pre}}
						</div>
						<div @click="nextTopic()" :class="currentNumber==totalnum?'bg-[#8FC3FF]':'bg-[#2979FF]'"
							class="min-w-[100px] px-[10px] box-border h-[28px] leading-[28px] text-center text-white text-[14px] rounded-[6px] cursor-pointer">
							{{langInfo.study_paper_answer_next}}
						</div>
					</div>
				</div>
				<div class="flex-1 h-[78vh] flex flex-col">
					<div
						class="flex-1 mb-[10px] flex flex-col shadow-01 rounded-[6px] pb-[20px] box-border   bg-white overflow-hidden">
						<div
							class="answerSheetTitle bB-01  p-[20px] box-border relative text-[16px] text-[#1B2128] font-bold">
							{{langInfo.study_paper_card}}
						</div>
						<div class="overflow-y-auto">
							<div v-if="type=='collect'||type=='userwrong'"
								class="flex flex-wrap overflow-y-auto  mb-[20px] py-[20px] px-[13px] box-border ">
								<div @click="selectTopic(item,index)"
									:class="[ item.userrecord && item.userrecord.user_answer == item.answer?'bg-[#68C340] text-white':'bg-[#ff6969] text-white', currentTopic==index?'bg-[#A6A6A6] text-white':'']"
									class="topicItem mb-[10px] cursor-pointer relative   flex items-center justify-center box-border"
									v-for="(item,index) in topicList" :key="index">
									<img v-if="item.is_user_question==1&&item.is_user_collection==1"
										src="@/static/image/icon55.png"
										class="w-[14px] h-[14px] absolute top-[0px] right-[0px]" alt="" srcset="" />
									<img v-else-if="item.is_user_question==1" src="@/static/image/icon55.png"
										class="w-[14px] h-[14px] absolute bottom-[0px] right-[0px]" alt="" srcset="" />

									<img v-if="item.is_user_collection==1" :src="collectActive"
										class="w-[14px] h-[14px] cursor-pointer absolute bottom-[0px] right-[0px]"
										alt="" srcset="" />
									<label class="cursor-pointer"> {{index + 1 }}</label>
								</div>
							</div>

							<div class=" mb-[20px] " v-else>
								<div v-if="seleList[0].length>0"
									class="flex flex-wrap    py-[20px] px-[13px] box-border">
									<div @click="selectTopic(item,index,'single')"
										:class="[ item.userrecord && (item.userrecord.user_answer ==item.answer)?'bg-[#68C340] text-white':'bg-[#ff6969] text-white',current_question_type=='single'&&currentTopic==index?'bg-[#A6A6A6] text-white':'']"
										class="topicItem mb-[10px] cursor-pointer relative   flex items-center justify-center box-border"
										v-for="(item,index) in seleList[0]" :key="index">
										<img v-if="item.is_user_question==1&&item.is_user_collection==1"
											src="@/static/image/icon55.png"
											class="w-[14px] h-[14px] absolute top-[0px] right-[0px]" alt="" srcset="" />
										<img v-else-if="item.is_user_question==1" src="@/static/image/icon55.png"
											class="w-[14px] h-[14px] absolute bottom-[0px] right-[0px]" alt=""
											srcset="" />

										<img v-if="item.is_user_collection==1" :src="collectActive"
											class="w-[14px] h-[14px] cursor-pointer absolute bottom-[0px] right-[0px]"
											alt="" srcset="" />
										<label class="cursor-pointer"> {{index + 1 }}</label>
									</div>
								</div>
								<div class="" v-if="seleList[1].length>0">
									<div class="" v-for="(item,index) in seleList[1]" :key="index">
										<div class="px-[20px] box-border relative text-[16px] text-[#1B2128] font-bold">
											{{langInfo['case']}} {{index+1}}
										</div>
										<div class="flex flex-wrap    py-[16px] px-[13px] box-border ">
											<div @click="selectCaseTopic(item,index,iteClass,indeClass ,'case')"
												:class="[ iteClass.userrecord && (iteClass.userrecord.user_answer ==iteClass.answer)?'bg-[#68C340] text-white':'bg-[#ff6969] text-white', current_question_type=='case'&& currentTopic==indeClass &&caseIndex==index?'bg-[#A6A6A6] text-white':'']"
												class="topicItem mb-[10px] cursor-pointer relative   flex items-center justify-center box-border"
												v-for="(iteClass,indeClass) in item.class" :key="indeClass">
												<img v-if="iteClass.is_user_question==1&&iteClass.is_user_collection==1"
													src="@/static/image/icon55.png"
													class="w-[14px] h-[14px] absolute top-[0px] right-[0px]" alt=""
													srcset="" />
												<img v-else-if="iteClass.is_user_question==1"
													src="@/static/image/icon55.png"
													class="w-[14px] h-[14px] absolute bottom-[0px] right-[0px]" alt=""
													srcset="" />

												<img v-if="iteClass.is_user_collection==1" :src="collectActive"
													class="w-[14px] h-[14px] cursor-pointer absolute bottom-[0px] right-[0px]"
													alt="" srcset="" />
												<label class="cursor-pointer"> {{indeClass + 1 }}</label>
											</div>
										</div>
									</div>
								</div>
							</div>

						</div>
					</div>

					<div @click="reportContinue()"
						class="shadow-01 mb-[10px] cursor-pointer rounded-[6px] h-[56px]  bg-[#3894FF] text-white flex items-center justify-center">
						{{langInfo.study_report_continue}}
					</div>

					<div @click="backStudyCenter()"
						class="shadow-01 rounded-[6px] cursor-pointer h-[56px]  bg-[#E6F2FF] text-[#3894FF] flex items-center justify-center">
						{{langInfo.study_paper_answer_back}}
					</div>
				</div>
			</div>
		</div>

		<!-- 提问/纠错 -->
		<questionCorrection :askVisible="askVisible" :order_item_id="order_item_id" :id="currentTopicInfo.id"
			:title="langInfo.study_question_tip" :course_subject_id="currentTopicInfo.course_subject_id"
			@close="closeVisible">
		</questionCorrection>
		<!-- 提问/纠错 -->
	</div>
</template>

<script>
	import { EventBus } from '../../js/event-bus.js';
	import questionCorrection from '@/components/questionCorrection.vue'

	import examHeader from '@/components/examHeader.vue'
	export default {
		components: {
			questionCorrection,
			examHeader
		},
		data() {
			return {
				watermarkContent: JSON.parse(localStorage.getItem('userInfo')).username + this.$common.currentTime() +
					'@港考通',
				svgWatermark1: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='140'><text x='0' y='100' transform='rotate(-30, 40, 100)' fill='%23999' font-size='14' opacity='0.2'>`,
				svgWatermark2: `</text></svg>")`,

				title: '',
				selectImg: require('@/static/image/icon37.png'),
				selectedImg: require('@/static/image/icon38.png'),

				collectActive: require('@/static/image/icon22Active.png'),
				collectImg: require('@/static/image/icon22.png'),

				questionActive: require('@/static/image/icon36Active.png'),
				questionImg: require('@/static/image/icon36.png'),
				optionsList: [],
				currentTopicInfo: {
					id: '',
					title: '',
					isCollect: false,
					isQuestion: false,
				},
				currentTopic: 0,

				topicList: [],
				askVisible: false, //疑问纠错
				identification: '',
				small_id: '',

				currentUserRecord: {
					id: '',
					user_answer: ''
				},
				type: '', //sele章节练习  userwrong错题练习  collect收藏练习
				langInfo: {},
				order_item_id: '',


				seleList: [
					[],
					[]
				],
				current_question_type: 'single',
				caseIndex: 0,
				caseTopicInfo: {},

				currentNumber: 0,

				totalnum: 0



			}
		},
		mounted() {
			this.identification = this.$route.query.identification
			this.small_id = this.$route.query.small_id
			this.type = this.$route.query.type

			this.order_item_id = this.$route.query.order_item_id


			this.langInfo = this.$store.getters['lang/getLangList']
			if (this.langInfo.length == 0) {
				this.getdict_data()
			}
			this.getQuestionInfo()
		},
		methods: {
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj

					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			getQuestionInfo() {
				this.$api.getQuestionPaper({
					small_id: this.small_id,
					identification: this.identification,
					type: this.type, //sele章节练习  userwrong错题练习  collect收藏练习
					analysis_type: 0,
					order_item_id: this.order_item_id
				}).then((res) => {
					console.log(res.data.order_item);
					this.order_item_id = res.data.order_item.id

					if (this.type == 'sele') {
						this.title = res.data.chapter_name + '-' + this.langInfo.study_exercise_chapter
					} else if (this.type == 'collect') {
						this.title = res.data.chapter_name + '-' + this.langInfo.study_collect_start
					} else if (this.type == 'userwrong') {
						this.title = res.data.chapter_name + '-' + this.langInfo.study_wrong_start
					}

					document.title = this.title
					if (this.type == 'collect' || this.type == 'userwrong') {
						this.currentTopic = res.data.data_log
						this.questionInfo = res.data
						// is_user_collection=是否收藏0否1是
						res.data.data.forEach((item, index) => {
							item.options.forEach((itm, ind) => {
								this.$set(itm, 'isSelect', false)
							})
						})
						this.topicList = res.data.data;

						this.totalnum = this.topicList.length
					} else {

						this.seleList = res.data.data
						let total = 0
						for (let j = 0; j < this.seleList[1].length; j++) {
							let itm = this.seleList[1][j];

							total = total + itm.class.length

						}
						this.totalnum = this.seleList[0].length + total
						this.seleList[1].forEach((item, index) => {
							item.class.forEach((itm, ind) => {
								itm.options.forEach((it, index_c) => {
									this.$set(it, 'isSelect', false)
								})
								if (itm.question_type == 5) {
									this.$set(itm, 'shortContent', '')
								} else if (itm.question_type == 3) {
									this.$set(item, 'isJudgmentSelect', -1)
								}
							})
						})

					}




					this.getCurrentInfo()

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			getCurrentInfo() {
				this.currentUserRecord = {
					id: '',
					user_answer: ''
				}

				if (this.type == 'sele') {
					if (this.current_question_type == 'single') {
						this.optionsList = []
						this.currentTopicInfo = this.seleList[0][this.currentTopic];

						this.optionsList = this.currentTopicInfo.options
						if (this.seleList[0][this.currentTopic].userrecord) {
							let userrecord = this.seleList[0][this.currentTopic].userrecord
							this.currentUserRecord = userrecord
							this.optionsList.forEach((item, index) => {
								if (userrecord.user_answer == item.key) {
									item.isSelect = true
								}
							})
						}
						
						
						this.currentTopicInfo.content = this.decodeHtml(this.currentTopicInfo.content)
						
						
					} else if (this.current_question_type == 'case') {

						this.optionsList = []

						this.currentTopicInfo = this.seleList[1][this.caseIndex].class[this.currentTopic];

						this.optionsList = this.currentTopicInfo.options

						if (this.seleList[1][this.caseIndex].class[this.currentTopic].userrecord) {
							let userrecord = this.seleList[1][this.caseIndex].class[this.currentTopic].userrecord
							this.currentUserRecord = userrecord
							this.optionsList.forEach((item, index) => {
								if (userrecord.user_answer == item.key) {
									item.isSelect = true
								}
							})
						}
						
						
						this.currentTopicInfo.content = this.decodeHtml(this.currentTopicInfo.content)
						
					}


				} else {
					this.optionsList = []
					this.currentTopicInfo = this.topicList[this.currentTopic]
					this.optionsList = this.currentTopicInfo.options

					if (this.topicList[this.currentTopic].userrecord) {
						let userrecord = this.topicList[this.currentTopic].userrecord
						this.currentUserRecord = userrecord

						this.optionsList.forEach((item, index) => {
							if (userrecord.user_answer == item.key) {
								item.isSelect = true
							}
						})
					}
					
					this.currentTopicInfo.content = this.decodeHtml(this.currentTopicInfo.content)
					
					
				}



				this.getCurrentNumber()
				this.get_user_log()
			},
			
			
			decodeHtml(html) {
				if (!html) return ''
			
				const textarea = document.createElement('textarea')
				textarea.innerHTML = html
			
				return textarea.value
			},
			
			getCurrentNumber() {
				if (this.type == 'sele') {
					if (this.current_question_type == 'single') {
						this.currentNumber = this.currentTopic + 1
					} else if (this.current_question_type == 'case') {

						let tpIndex = 0
						let isExit = false

						for (let j = 0; j < this.seleList[1].length; j++) {
							let itm = this.seleList[1][j];

							if (isExit == true) {
								break
							}
							for (let d = 0; d < itm.class.length; d++) {
								if (this.caseIndex == j && this.currentTopic == d) {
									isExit = true
									break;
								}
								tpIndex++
							}
						}
						this.currentNumber = this.seleList[0].length + tpIndex + 1
					}
				} else {
					this.currentNumber = this.currentTopic + 1
				}
			},
			get_user_log() {
				// type: '', //sele章节练习  userwrong错题练习  collect收藏练习

				let logoType = 3
				if (this.type == 'collect') {
					logoType = 5
				} else if (this.type == 'userwrong') {
					logoType = 4
				}

				this.$api.user_log({
					action: 'question',
					type: logoType, // type 类型:3章节练习,4=错题练习,5=收藏练习
					course_question_id: this.currentTopicInfo.id
				}).then((res) => {
					console.log(res);
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},


			// 上一页
			preTopic() {

				if (this.currentNumber == 1) {
					return
				}


				if (this.type == 'sele') {

					if (this.current_question_type == 'single') {
						this.currentTopic--;

						this.getCurrentInfo()

					} else if (this.current_question_type == 'case') {

						if (this.caseIndex == 0 && this.currentTopic == 0) {

							this.current_question_type = 'single'
							this.currentTopic = this.seleList[0].length - 1
							this.getCurrentInfo()
							return
						}

						if (this.caseIndex > 0 && this.currentTopic == 0) {
							this.caseIndex--;
							this.currentTopic = this.seleList[1][this.caseIndex].class.length - 1;
							this.getCurrentInfo()
							return
						}
						this.currentTopic--
						this.getCurrentInfo()

					}


				} else {
					if (this.currentTopic == 0) {
						return
					}
					this.currentTopic--;

					localStorage.setItem('currentTopic', this.currentTopic)
					this.getCurrentInfo()
				}


			},
			nextTopic() {

				if (this.currentNumber == this.totalnum) {
					return
				}


				if (this.type == 'sele') {
					if (this.current_question_type == 'single') {
						if (this.currentTopic == this.seleList[0].length - 1) {
							this.current_question_type = 'case'
							this.caseIndex = 0;
							this.currentTopic = 0
							this.getCurrentInfo()
							return
						}
						this.currentTopic++
						this.getCurrentInfo()
					} else if (this.current_question_type == 'case') {
						if (this.currentTopic + 1 == this.seleList[1][this.caseIndex].class.length) {
							if (this.caseIndex + 1 == this.seleList[1][this.caseIndex].length) {
								return
							}

							this.caseIndex++;
							this.currentTopic = 0
							this.getCurrentInfo()
							return
						}

						this.currentTopic++
						this.getCurrentInfo()

					}
				} else {
					if (this.currentTopic == this.topicList.length - 1) {
						return
					}
					this.currentTopic++
					this.getCurrentInfo()
				}
			},
			selectTopic(item, index, type) {
				this.caseTopicInfo = {}
				this.current_question_type = type
				this.currentTopic = index;

				this.getCurrentInfo()
			},
			selectCaseTopic(item, index, iteClass, indeClass, type) {
				this.caseTopicInfo = item
				this.current_question_type = type
				this.currentTopic = indeClass;
				this.caseIndex = index
				this.getCurrentInfo()

			},
			// 返回学习中心
			backStudyCenter() {
				window.close()
				// this.$router.go(-4);
			},
			// 收藏
			collectClick() {
				if (this.currentTopicInfo.is_user_collection == 1) {
					this.currentTopicInfo.is_user_collection = 0
				} else {
					this.currentTopicInfo.is_user_collection = 1
				}
				if (this.type == 'sele') {
					if (this.current_question_type == 'single') {

						this.seleList[0][this.currentTopic].is_user_collection = this.currentTopicInfo.is_user_collection
					} else if (this.current_question_type == 'case') {
						this.seleList[1][this.caseIndex].class[this.currentTopic].is_user_collection = this
							.currentTopicInfo.is_user_collection
					}

				} else {
					this.topicList[this.currentTopic].is_user_collection = this.currentTopicInfo.is_user_collection
				}


				// type=类型:1=课程,2=咨询,3=资源,4=题目
				// course_course_id=课程id
				// course_question_id=题目id
				this.$api.addUserCollection({
					type: 4,
					course_question_id: this.currentTopicInfo.id
				}).then((res) => {
					console.log(res);
					// status=0 0是取消1是收藏成功
					if (res.data.status == 1) {
						this.$message({
							message: res.msg,
							type: 'success'
						})
					} else {
						this.$message({
							message: res.msg,
							type: 'warning'
						})
					}

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			closeVisible() {
				this.askVisible = false
			},
			reportContinue() {


				this.$confirm(this.langInfo.continue_exam_tip, this.langInfo.reg_tip, {
					confirmButtonText: this.langInfo.study_paper_confirm,
					cancelButtonText: this.langInfo.cancel,
					type: 'info'
				}).then((ms) => {
					console.log(ms);
					if (ms == "confirm") {

						var mode = 1
						if (this.type == 'collect') {
							mode = 2
						} else if (this.type == "userwrong") {
							mode = 3
						}

						// EventBus.$emit('reportContinue', {
						// 	small_id: this.small_id,
						// 	order_item_id: this.questionInfo.order_item_id,
						// 	mode: mode
						// })

						this.$router.go(-3);

					}
				}).catch(() => {});



			}

		}
	}
</script>

<style scoped>
	/* 	::-webkit-scrollbar {
		display: none;
	} */
	
	/deep/p img{
		width: 100% !important;
	}


	.answerSheetTitle::after {
		content: '';
		position: absolute;
		width: 4px;
		height: 21px;
		background-color: rgba(103, 194, 58, 1);
		left: 0;
		top: 50%;
		transform: translateY(-50%);
	}

	.topicItem:nth-child(5n) {
		margin-right: 0;

	}

	.topicItem {
		width: 18%;
		height: 30px;
		line-height: 30px;
		margin-right: 2.5%;
		border: 1px solid rgba(187, 187, 187, 1);
	}
</style>